import React, { Component } from 'react';
import 'whatwg-fetch';
import 'rc-slider/assets/index.css';

import './App.css';
import HexBoard from './HexBoard';
import GameList from './GameList';
import { gamesWithRatings, splitByMove } from './processGames';
import extractGamedata from './extractGamedata';
import Slider from 'rc-slider';

const Range = Slider.createSliderWithTooltip(Slider.Range);

function intersectRanges(a, b) {
  return [Math.max(a[0], b[0]), Math.min(a[1], b[1])];
}

// TODO: get a proper icon
// TODO: think of a good name
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: 13,
      moves: [],
      moveData: null,
      gamedata: null,
      gamesWithRatings: null,
      timeBounds: null,
      timeRange: null,
      ratingRange: null,
    };
  }

  async componentDidMount() {
    const gamedata = extractGamedata(JSON.parse(await (await fetch(process.env.PUBLIC_URL + '/gamedata.json')).text()));
    const withRatings = gamesWithRatings(this.state.size, gamedata.games);
    const timeBounds = this.getTimeBounds(withRatings);
    const ratingBounds = this.getRatingBounds(withRatings);
    // TODO: should we actually store this computed data in the state?
    // TODO: also, the update logic is getting a bit complicated
    this.setState({
      gamedata,
      gamesWithRatings: withRatings,
      moveData: splitByMove(withRatings, this.state.moves),
      timeBounds,
      timeRange: timeBounds,
      ratingBounds,
      ratingRange: ratingBounds,
    });
  }

  getRatingBounds(gamesWithRatings) {
    let minRating = Infinity, maxRating = -Infinity;
    for (let entry of gamesWithRatings) {
      minRating = Math.min(minRating, entry.ratings[0], entry.ratings[1]);
      maxRating = Math.max(maxRating, Math.min(entry.ratings[0], entry.ratings[1]));
    }
    return [minRating - 1, maxRating + 1];
  }

  pushMove(move) {
    const moves = this.state.moves.slice();
    moves.push(move);
    this.updateMoves(moves);
  }

  popMove() {
    const moves = this.state.moves.slice();
    moves.pop();
    this.updateMoves(moves);
  }

  resetMoves() {
    this.updateMoves([]);
  }

  updateMoves(moves) {
    const newState = {moves};
    if (this.state.gamesWithRatings) {
      newState.moveData = splitByMove(this.state.gamesWithRatings, moves);
    }
    this.setState(newState);
  }

  updateGames(size, timeRange, ratingRange) {
    const withRatings = gamesWithRatings(size, this.state.gamedata.games);
    const timeBounds = this.getTimeBounds(withRatings);
    const ratingBounds = this.getRatingBounds(withRatings);
    const filteredGames = [];
    for (let entry of withRatings) {
      if (entry.game.time < timeRange[0] || entry.game.time > timeRange[1] ||
        Math.min(entry.ratings[0], entry.ratings[1]) < ratingRange[0] ||
        Math.max(entry.ratings[0], entry.ratings[1]) > ratingRange[1]) {
        continue;
      }
      filteredGames.push(entry);
    }
    this.setState({
      size,
      timeBounds,
      timeRange: intersectRanges(timeRange, timeBounds),
      ratingBounds,
      ratingRange: intersectRanges(ratingRange, ratingBounds),
      gamesWithRatings: filteredGames,
      moves: [],
      moveData: splitByMove(filteredGames, []),
    });
  }

  getTimeBounds(gamesWithRatings) {
    let lowestTime = Infinity, highestTime = -Infinity;
    for (let entry of gamesWithRatings) {
      lowestTime = Math.min(lowestTime, entry.game.time);
      highestTime = Math.max(highestTime, entry.game.time);
    }
    return [lowestTime, highestTime];
  }

  setSize(size) {
    this.updateGames(size, this.state.timeRange, this.state.ratingRange);
  }

  updateTimeRange(timeRange) {
    this.updateGames(this.state.size, timeRange, this.state.ratingRange);
  }

  updateRatingRange(ratingRange) {
    this.updateGames(this.state.size, this.state.timeRange, ratingRange);
  }

  sizeControls() {
    const result = [];
    for (let size of [11, 13, 19]) {
      if (this.state.size !== size) {
        result.push(<a onClick={() => this.setSize(size)}>{size}</a>);
      } else {
        result.push(<span className="sizeLabel">{size}</span>);
      }
    }
    return result;
  }

  render() {
    if (this.state.gamedata == null) {
      return <div className="loadingScreen">Loading...</div>;
    }
    console.log(this.state);
    return (
      <div className="app">
        <HexBoard
          size={this.state.size}
          moves={this.state.moves}
          moveData={this.state.moveData}
          onMove={(move) => this.pushMove(move)}
        />
        <div className="auxiliary">
          <div className="controls">
            <a onClick={() => this.popMove()}>Back</a>
            <a onClick={() => this.resetMoves()}>Reset</a>
            <span className="sizeLabel">Size:</span>
            {this.sizeControls()}
            <div>
              <div className="rangeControl">
                Date filter
                <Range
                  className="range"
                  min={this.state.timeBounds[0]}
                  max={this.state.timeBounds[1]}
                  defaultValue={this.state.timeRange}
                  tipFormatter={value => new Date(value).toISOString().substring(0, 10)}
                  onAfterChange={(timeRange) => this.updateTimeRange(timeRange)}
                />
              </div>
              <div className="rangeControl">
                Rating filter
                <Range
                  className="range"
                  min={this.state.ratingBounds[0]}
                  max={this.state.ratingBounds[1]}
                  step={0.01}
                  defaultValue={this.state.ratingRange}
                  tipFormatter={value => Math.round(1500 + value * 400 / Math.log(10))}
                  onAfterChange={(ratingRange) => this.updateRatingRange(ratingRange)}
                />
              </div>
            </div>
          </div>
          <GameList
            size={this.state.size}
            gamedata={this.state.gamedata}
            gamesWithRatings={this.state.gamesWithRatings}
            moves={this.state.moves}
            onMove={(move) => this.pushMove(move)}
          />
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js